export function getAWSEnvironment() {
  const mapping = {
    production: 'sso',
    prodstage: 'sso',
    localhost: 'dev',
    development: 'dev',
    stage: 'dev',
    etsNext: 'etsNext',
    etsNextSit: 'etsNext-Sit',
  };

  const activeEnvironment = mapping[process.env.ENVIRONMENT];

  if (!activeEnvironment) {
    throw new Error('Invalid environment supplied. No AWS environment found.');
  }

  return activeEnvironment;
}

export function getAWSResourcePrefix() {
  const map = {
    production: 'sso',
    prodstage: 'prodstage',
    etsNext: 'etsNext',
    etsNextSit: 'etsNext-Sit',
    localhost: 'dev',
    development: 'dev',
    stage: 'stage',
  };

  const awsEnv = map[process.env.ENVIRONMENT];

  if (!awsEnv) {
    throw new Error(
      'Invalid environment supplied. No AWS resource prefix found.'
    );
  }

  return awsEnv;
}

export function getAWSRegion() {
  const awsEnvironment = getAWSEnvironment();

  const mappedRegions = {
    sso: 'us-east-1',
    dev: 'us-east-2',
    etsNext: 'us-east-1',
    'etsNext-Sit': 'us-east-1',
  };
  const mappedRegion = mappedRegions[awsEnvironment];

  if (!mappedRegion) {
    throw new Error('Invalid environment supplied. No AWS region found.');
  }

  return mappedRegion;
}

export function getAWSCredentials() {
  const awsEnvironment = getAWSEnvironment();

  if (['sso', 'dev'].includes(awsEnvironment)) {
    const accessKeyId = process.env.AWS_ACCESS_KEY_ID;
    const secretAccessKey = process.env.AWS_SECRET_ACCESS_KEY;
    if (accessKeyId && secretAccessKey) {
      return {
        credentials: {
          accessKeyId,
          secretAccessKey,
        },
      };
    }
    return {};
  } else if (['etsNext', 'etsNext-Sit'].includes(awsEnvironment)) {
    return {};
  } else {
    throw new Error('Invalid environment supplied. No AWS credentials found.');
  }
}

export function getAWSAccountId() {
  const awsEnvironment = getAWSEnvironment();

  const mappedAccountIds = {
    dev: 636737175167,
    sso: 443660446114,
    etsNext: 741448935083,
    'etsNext-Sit': 285795751960,
  };
  const mappedAccountId = mappedAccountIds[awsEnvironment];

  if (!mappedAccountId) {
    throw new Error('Invalid environment supplied. No AWS account ID found.');
  }

  return mappedAccountId;
}
